import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isFetching: false,
};

const fetchSlice = createSlice({
  name: 'fetch',
  initialState: initialState,
  reducers: {
    setIsFetching(state, { payload }) {
      // prevent unnecessary state change
      if (
        (state.isFetching && payload.isFetching) ||
        (!state.isFetching && !payload.isFetching)
      ) {
        return;
      }
      state.isFetching = payload.isFetching;
    },
  },
});

export default fetchSlice.reducer;

export const { setIsFetching } = fetchSlice.actions;
